import PersonalInfo from './PrefillSteps.personalInfo.view';
import PhoneInput from './PrefillSteps.phoneInput.view';
import PhoneVerify from './PrefillSteps.phoneVerify.view';
import personalInfoValidation from './PrefillSteps.personalInfo.validation';
import phoneVerifyValidation from './PrefillSteps.phoneVerify.validation';
import * as phoneInputValidation from './PrefillSteps.phoneInput.validation';

const defaultPhoneValidation = 'us';

const defineStep = (component, validationConfig) => ({
  component,
  validationConfig,
});

export default ({ phoneValidation = defaultPhoneValidation } = {}) => ([
  defineStep(PhoneInput, phoneInputValidation[phoneValidation]),
  defineStep(PhoneVerify, phoneVerifyValidation),
  defineStep(PersonalInfo, personalInfoValidation),
]);
